import React from 'react'

import type { SentBubbleProps } from '../../types'
import BubbleShell from '../_shared/BubbleShell'

/**
 * A message bubble in the sender's own treatment — dark surface, right-side
 * tail. Use to preview how a message looks *to you in the channel*.
 *
 * Note: the variant is a visual treatment, not an authorship claim. To preview
 * an outgoing message as the *recipient* will see it, use
 * `MessageBubble.Received` instead.
 */
const SentCard: React.FC<SentBubbleProps> = ({ text, tail, className }) => (
  <BubbleShell variant="sent" text={text} tail={tail} className={className} />
)

export default SentCard
